// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"progress_wrapper_1OA0-","title":"progress_title_1SpDd","progress":"progress_progress_3C3Cq"};